import { type DatabaseFilter } from '@databases/types/database/view';
import React, { FunctionComponent, useCallback, useState } from 'react';

import { ViewSettingsFilterRuleEdit } from './ViewSettingsFilterRuleEdit';
import { ViewSettingsFilterRuleView } from './ViewSettingsFilterRuleView';

export interface ViewSettingsFilterRuleProps {
  contentId: string;
  filter: DatabaseFilter;
  onDelete: () => void;
  onSubmit: (filter: DatabaseFilter) => void;
}

export const ViewSettingsFilterRule: FunctionComponent<ViewSettingsFilterRuleProps> = ({
  contentId,
  filter,
  onDelete,
  onSubmit,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleCancel = useCallback(() => {
    setIsEditing(false);
  }, []);

  const handleEdit = useCallback(() => {
    setIsEditing(true);
  }, []);

  const handleSubmit = useCallback(
    (filter: DatabaseFilter) => {
      onSubmit(filter);
      setIsEditing(false);
    },
    [onSubmit]
  );

  if (!isEditing) {
    return (
      <ViewSettingsFilterRuleView
        contentId={contentId}
        filter={filter}
        onEdit={handleEdit}
        onDelete={onDelete}
      />
    );
  }

  return (
    <ViewSettingsFilterRuleEdit
      contentId={contentId}
      filter={filter}
      onCancel={handleCancel}
      onDelete={onDelete}
      onSubmit={handleSubmit}
    />
  );
};
